import { useIonLoading } from '@ionic/react';
import { useCallback, useEffect } from 'react';
import { t } from 'ttag';

/**
 * Use this hook by passing in `loading`, or by calling `present` and `dismiss` directly
 */
export default function useLoading(loading?: boolean) {
  const [present, dismiss] = useIonLoading();

  const presentLoading = useCallback(async () => {
    await present({
      message: t`Loading...`,
    });
  }, [present]);

  useEffect(() => {
    async function effect() {
      if (loading) {
        await presentLoading();
      } else {
        await dismiss();
      }
    }
    if (loading !== undefined) {
      effect();
    }

    return () => {
      dismiss();
    };
  }, [present, dismiss, loading, presentLoading]);

  return { presentLoading, dismissLoading: dismiss };
}
